import { MortgageFormValues } from '@app/sign-up/forms/mortgage.form';
import { createAction, props } from '@ngrx/store';
import { SignUpMortgageState } from '@shared/store/sign-up/mortgage/mortgage.state';

export const loadSignUpMortgageFromStorage = createAction('[SIGN UP] Load Mortgage From Storage');
export const loadSignUpMortgageFromStorageSuccess = createAction(
  '[SIGN UP] Load Mortgage From Storage Success',
  props<{ state: SignUpMortgageState | null }>(),
);

export const saveSignUpMortgageToStorage = createAction('[SIGN UP] Save Mortgage To Storage', props<MortgageFormValues>());

export const clearSignUpMortgageFromStorage = createAction('[SIGN UP] Clear Mortgage From Storage');

export const skipSignUpMortgageCreation = createAction('[SIGN UP] Skip Mortgage Creation');

export const setSignUpMortgageRateByPayments = createAction('[SIGN UP] Set Mortgage Rate By Payments', props<{ monthlyPayment: number }>());
